module.exports = __webpack_public_path__ + "img/Butterfly_00113.adc04b57.png";